export default "__VITE_ASSET__t6Wduj11P_jK5EMZSUaG9A__"